module.exports = __webpack_public_path__ + "img/Info-circle.fd7b14e7.svg";